
import {Component, Vue} from 'vue-facing-decorator';
import { ref } from "vue";
import Loading from 'vue-loading-overlay';

@Component({
    name: 'mjkn-view',
    components: {       
        'loading'    : Loading,
    }
})
export default class MjknView extends Vue{
    page       = ref(null);
    loading    = false;
    message    = "";

    p = {
    "id": 777,
    "date": "2024-08-21T20:54:39",
    "date_gmt": "2024-08-21T13:54:39",
    "guid": {
        "rendered": "https://rsudgeneng.ngawikab.go.id/?page_id=777"
    },
    "modified": "2024-09-26T08:02:43",
    "modified_gmt": "2024-09-26T01:02:43",
    "slug": "pendaftaran-online-pasien-bpjs-melalui-mobile-jkn",
    "status": "publish",
    "type": "page",
    "link": "https://rsudgeneng.ngawikab.go.id/pendaftaran-online-pasien-bpjs-melalui-mobile-jkn/",
    "title": {
        "rendered": "PENDAFTARAN ONLINE PASIEN BPJS MELALUI MOBILE JKN"
    },
    "content": {
        "rendered": "\n\u003Col class=\"wp-block-list\"\u003E\n\u003Cli\u003EDownload Aplikasi Mobile JKN di App Store / Playstore\u003C/li\u003E\n\n\n\n\u003Cli\u003ERegistrasi dengan mengisi form-form\u003C/li\u003E\n\n\n\n\u003Cli\u003ELogin dengan menggunakan NIK dan Nomor HP\u003C/li\u003E\n\n\n\n\u003Cli\u003EMasukan Nomor Rujukan\u003C/li\u003E\n\n\n\n\u003Cli\u003EPilih FKTL Tujuan\u003C/li\u003E\n\n\n\n\u003Cli\u003EPilih Poliklinik\u003C/li\u003E\n\n\n\n\u003Cli\u003EDaftar\u003C/li\u003E\n\u003C/ol\u003E\n\n\n\n\u003Cfigure class=\"wp-block-embed is-type-video is-provider-youtube wp-block-embed-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio\"\u003E\u003Cdiv class=\"wp-block-embed__wrapper\"\u003E\n\u003Ciframe loading=\"lazy\" title=\"PENTING BANGET! INILAH TUTORIAL PENDAFTARAN DAN LOGIN PENGGUNA APLIKASI MOBILE JKN\" width=\"750\" height=\"422\" src=\"https://www.youtube.com/embed/ML2vGaaiQK8?feature=oembed\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" allowfullscreen\u003E\u003C/iframe\u003E\n\u003C/div\u003E\u003C/figure\u003E\n\n\n\n\u003Cfigure class=\"wp-block-image size-large\"\u003E\u003Cimg loading=\"lazy\" decoding=\"async\" width=\"724\" height=\"1024\" src=\"https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/Lebih-Mudah-Antri-Pelayanan-dengan-Mobile-JKN_page-0001-724x1024.jpg\" alt=\"\" class=\"wp-image-778\" srcset=\"https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/Lebih-Mudah-Antri-Pelayanan-dengan-Mobile-JKN_page-0001-724x1024.jpg 724w, https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/Lebih-Mudah-Antri-Pelayanan-dengan-Mobile-JKN_page-0001-212x300.jpg 212w, https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/Lebih-Mudah-Antri-Pelayanan-dengan-Mobile-JKN_page-0001-768x1086.jpg 768w, https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/Lebih-Mudah-Antri-Pelayanan-dengan-Mobile-JKN_page-0001-1086x1536.jpg 1086w, https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/Lebih-Mudah-Antri-Pelayanan-dengan-Mobile-JKN_page-0001-1448x2048.jpg 1448w, https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/Lebih-Mudah-Antri-Pelayanan-dengan-Mobile-JKN_page-0001-scaled.jpg 1810w\" sizes=\"auto, (max-width: 724px) 100vw, 724px\" /\u003E\u003C/figure\u003E\n",
        "protected": false
    },
    "excerpt": {
        "rendered": "",
        "protected": false
    },
    "author": 2,
    "featured_media": 0,
    "parent": 0,
    "menu_order": 0,
    "comment_status": "closed",
    "ping_status": "closed",
    "template": "",
    "meta": {
        "_joinchat": [],
        "footnotes": ""
    },
    "class_list": [
        "post-777",
        "page",
        "type-page",
        "status-publish",
        "hentry"
    ],
    "jetpack_sharing_enabled": true,
    "_links": {
        "self": [
        {
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/777",
            "targetHints": {
            "allow": [
                "GET"
            ]
            }
        }
        ],
        "collection": [
        {
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages"
        }
        ],
        "about": [
        {
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/types/page"
        }
        ],
        "author": [
        {
            "embeddable": true,
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/users/2"
        }
        ],
        "replies": [
        {
            "embeddable": true,
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/comments?post=777"
        }
        ],
        "version-history": [
        {
            "count": 1,
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/777/revisions"
        }
        ],
        "predecessor-version": [
        {
            "id": 779,
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/777/revisions/779"
        }
        ],
        "wp:attachment": [
        {
            "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/media?parent=777"
        }
        ],
        "curies": [
        {
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }
        ]
    }
    }

    async mounted () {
        this.message = ""
        this.loading = true;
        try {
            const response = await fetch('https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/777', {
                mode: 'cors',
            });
            this.page = await response.json();
            
        }catch (error) { 
            console.log(error)
            this.message = "Maaf, Terjadi Kendala!!"
        }
        this.loading = false;

        this.$nextTick(() => {
            if (window.innerWidth <= 767) {
                const iframes = document.querySelectorAll('#my-konten iframe');
                iframes.forEach((iframe :any) => {
                iframe.style.width = '100%';
                iframe.style.height = 'auto';
                });

                const img = document.querySelectorAll('#my-konten img');
                img.forEach((img :any) => {
                    img.style.width = '100%';
                    img.style.height = 'auto';
                });
            }
        });
    }
}
        